import memoize from 'fast-memoize';
import { createSelector } from 'reselect';

import { State } from '../Store';

export const selectLocations = (state: State) => state.locations || [];

export const selectLocation = memoize((id: number | null) =>
  id
    ? createSelector(
        [selectLocations],
        locations => locations.find(location => location.id === id)
      )
    : () => undefined
);
